import { useEffect, useState } from 'react'
import { createFileRoute, Link } from '@tanstack/react-router'
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { unsubscribeLocationWatchman } from '@/features/accommodation/detail/components/location-watchman/unsubscribeLocationWatchman'
import { SITE_NAME, noindexMeta } from '@/lib/seo/siteMeta'

export const Route = createFileRoute('/_layout/location-watchman/unsubscribe/$token')({
  component: UnsubscribeLocationWatchmanPage,
  head: () => ({
    meta: [{ title: `Odhlášení z hlídání termínů | ${SITE_NAME}` }, ...noindexMeta()],
  }),
})

type Status = 'loading' | 'success' | 'error'

function UnsubscribeLocationWatchmanPage() {
  const { token } = Route.useParams()
  const [status, setStatus] = useState<Status>('loading')

  useEffect(() => {
    let cancelled = false

    unsubscribeLocationWatchman(token)
      .then(() => {
        if (!cancelled) setStatus('success')
      })
      .catch(() => {
        if (!cancelled) setStatus('error')
      })

    return () => {
      cancelled = true
    }
  }, [token])

  return (
    <div className="container flex min-h-[50vh] flex-col items-center justify-center py-16 text-center">
      {status === 'loading' && (
        <>
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-red-600" />
          <p className="text-slate-600">Odhlašujeme…</p>
        </>
      )}

      {status === 'success' && (
        <>
          <CheckCircle2Icon className="mb-4 h-12 w-12 text-green-500" />
          <h1 className="mb-2 text-2xl font-semibold text-slate-700">Odhlášeno</h1>
          <p className="mb-6 max-w-sm text-slate-500">
            Už vám nebudeme posílat upozornění na volné termíny u tohoto místa.
          </p>
          <Button asChild>
            <Link to="/">Zpět na hlavní stránku</Link>
          </Button>
        </>
      )}

      {status === 'error' && (
        <>
          <XCircleIcon className="mb-4 h-12 w-12 text-red-500" />
          <h1 className="mb-2 text-2xl font-semibold text-slate-700">Něco se nepovedlo</h1>
          <p className="mb-6 max-w-sm text-slate-500">Zkuste odkaz otevřít znovu.</p>
          <Button asChild>
            <Link to="/">Zpět na hlavní stránku</Link>
          </Button>
        </>
      )}
    </div>
  )
}
